import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"gesture-slide-up"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M7.83219 7.90139L12.2246 15.5093L8.93878 16.543C8.59262 16.6519 8.34907 16.9625 8.32581 17.3246L8.26295 18.3037L14.119 20.7232C14.6233 20.9315 15.1957 20.8938 15.6683 20.621L21.8045 17.0782C22.4594 16.7001 22.7989 15.9452 22.6471 15.2043L21.5155 9.67942C21.3487 8.8651 20.634 8.27914 19.8028 8.27519L15.6059 8.25528C15.2947 8.25381 14.9887 8.33502 14.7192 8.49062L12.85 9.56979L10.8731 6.14571C10.3883 5.30598 9.31454 5.01827 8.47481 5.50309C7.63508 5.9879 7.34737 7.06166 7.83219 7.90139Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M7.83219 7.90139L12.2246 15.5093L8.93878 16.543C8.59262 16.6519 8.34907 16.9625 8.32581 17.3246L8.26295 18.3037L14.119 20.7232C14.6233 20.9315 15.1957 20.8938 15.6683 20.621L21.8045 17.0782C22.4594 16.7001 22.7989 15.9452 22.6471 15.2043L21.5155 9.67942C21.3487 8.8651 20.634 8.27914 19.8028 8.27519L15.6059 8.25528C15.2947 8.25381 14.9887 8.33502 14.7192 8.49062L12.85 9.56979L10.8731 6.14571C10.3883 5.30598 9.31454 5.01827 8.47481 5.50309C7.63508 5.9879 7.34737 7.06166 7.83219 7.90139Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M5.19787 5.50101V2.51573L1.4982 2.51367M4.51472 19.4863C-0.0134036 14.9582 -0.166234 7.71159 4.05623 2.99996","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const GestureSlideUp = Vue.extend<IconProps>({
  name: 'GestureSlideUpIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'gesture-slide-up',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default GestureSlideUp;
